import React from "react";

/**
 * FormNavigation Component
 *
 * Displays Back and Save & Exit buttons at the top of each form step.
 *
 * @param {Function} onBack - Handler for back button click
 * @param {Function} onSaveAndExit - Handler for save & exit button click
 * @param {boolean} showBack - Whether to show the back button (default: true)
 * @param {boolean} showSaveExit - Whether to show save & exit button (default: true)
 */
const FormNavigation = ({
  onBack,
  onSaveAndExit,
  showBack = true,
  showSaveExit = true,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "24px",
      }}
    >
      {/* Back Button */}
      {showBack && (
        <button
          onClick={onBack}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#525252",
            backgroundColor: "transparent",
            border: "1px solid #e5e5e5",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#a3a3a3";
            e.currentTarget.style.backgroundColor = "#fafafa";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#e5e5e5";
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Back
        </button>
      )}

      {/* Spacer when back button is hidden */}
      {!showBack && <div />}

      {/* Save & Exit Button */}
      {showSaveExit && (
        <button
          onClick={onSaveAndExit}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#525252",
            backgroundColor: "transparent",
            border: "1px solid #e5e5e5",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#a3a3a3";
            e.currentTarget.style.backgroundColor = "#fafafa";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#e5e5e5";
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          Save & Exit
        </button>
      )}
    </div>
  );
};

export default FormNavigation;
